export default {"src":"/_next/static/media/tick_black.70341d74.svg","height":14,"width":14};